import { transformDateValue } from 'core/js/FormUtils';
export const getTemplateView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let templateList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Asset Name","fieldValue":transformDataValue(data.assetname,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          templateList.push(card);
  })
  return templateList;
}